export class HttpTimeoutError extends Error {
	constructor(public httpTimeoutMessage: string) {
		super(httpTimeoutMessage);
	}
}

export function isHttpTimeoutError(error: HttpTimeoutError): error is HttpTimeoutError {
	return error.httpTimeoutMessage !== undefined;
}
